import { Injectable, OnChanges, EventEmitter } from '@angular/core';
import * as _ from 'underscore';
import { IdentityAuthService } from '../identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class NestedNavigationService {
  public get header() {
    var headerFilter = this.headers.filter(o => o.listIndex == this.routeParams.listIndex)
    if (headerFilter.length > 0)
      return headerFilter[0];
  };
  public headers: any = [];
	public loading: boolean = false;
	private _actions: any;
  public routeParams: any = {};
  public routeExtraData: any;
  private _currentRouteParams: any;
  public get currentRouteParams() {
    return this._currentRouteParams;
  }
  public set currentRouteParams(value) {
    this._currentRouteParams = value;
    this.currentRouteParamsChange.emit(value);
  }
  public currentRouteParamsChange = new EventEmitter();
  public actionsPerPanel: any = new Array();

  public currentApp: any;
  public refreshRelatedListsTriggered = new EventEmitter();
	public get actions() {
		var exists = this.actionsPerPanel.filter(z => {
			return z.route == this.routeParams.route && z.listIndex == this.routeParams.listIndex
		});
		if (exists.length > 0)
			return exists[0].actions //_.sortBy(exists[0].actions, function (o) { return o.sortOrder; });
		else return new Array();
	}

	public get groupedActions() {
		var exists = this.actionsPerPanel.filter(z => {
			return z.route == this.routeParams.route && z.listIndex == this.routeParams.listIndex
		});
		if (exists.length > 0)
			return exists[0].groupedActions;
		else return new Array();
	}
  constructor(private auth: IdentityAuthService,
    public router: Router,
    public route: ActivatedRoute) {

	}

  public groupActions(isSameForm) {
		if (!this.actions || !isSameForm)
			this.groupedActions.splice(0);
		//Add new
		var exists = this.actionsPerPanel.filter(z => {
			return z.route == this.routeParams.route && z.listIndex == this.routeParams.listIndex
		});
		if (exists.length > 0)
			exists[0].actions = _.sortBy(exists[0].actions, function (o) { return o.sortOrder; });

		this.actions.forEach(o => {
			if (o.groupName) {
				var exists = this.groupedActions.filter(z => { return z.groupName == o.groupName });
				if (exists.length > 0) {
					var existsInGroup = exists[0].items.filter(z => {
						return o.label == z.label
					});
					if (existsInGroup.length == 0) {

						o.newItem = true;
						exists[0].items.push(o);
					}
					else this.setExisting(existsInGroup[0], o)
				}
				else this.groupedActions.push({ groupName: o.groupName, items: [o], expanded: o.expanded, sortOrder: o.sortOrder ? o.sortOrder : this.groupedActions.length, permissions: o.permissions })
			}
			else {
				var exists = this.groupedActions.filter(z => {
					if (z.item)
						return o.label == z.item.label;
					else return false;
				});
				if (exists.length == 0) {
					o.newItem = true;
					this.groupedActions.push({ groupName: '', item: o, expanded: o.expanded, sortOrder: o.sortOrder ? o.sortOrder : this.groupedActions.length, permissions: o.permissions })
				}
				else this.setExisting(exists[0], o)
			}
		})

		var groupItemsToRemove = new Array();
		//delete extra
		var groupsToRemove = new Array();
		this.groupedActions.forEach(o => {
			if (o.groupName == '') {
				var exists = this.actions.filter(z => {
					return !z.groupName && z.label == o.item.label
				});
				if (exists.length == 0) {
					o.removeItem = true;
					groupsToRemove.push(o);
				}
			} else {
				var exists = this.actions.filter(z => {
					return z.groupName == o.groupName
				});
				if (exists.length == 0) {
					o.removeItem = true;
					groupsToRemove.push(o);
				}
				else {
					o.items.forEach(gi => {
						var existsGroupItem = exists.filter(z => {
							return z.label == gi.label
						});
						if (existsGroupItem.length == 0) {
							gi.removeItem = true;
							groupItemsToRemove.push({ group: o, item: gi });
						}
					})

				}
			}
		})

		var self = this;
		var removeItems = function () {
			groupItemsToRemove.forEach(gi => {
				self.groupedActions[gi.group].items.splice(self.groupedActions[gi.group].items.indexOf(gi.item), 1);
				if (self.groupedActions[gi.group].items.length == 0)
					groupsToRemove.push(gi.group);
			})
			groupsToRemove.forEach(o => {
				self.groupedActions.splice(self.groupedActions.indexOf(o), 1);
			})
		}

		removeItems();
		if (exists.length > 0)
			exists[0].groupedActions = _.sortBy(exists[0].groupedActions, function (o) { return o.sortOrder });
		return this.groupedActions;
	}

	public anyActionVisible(items) {
		if (!items)
			return false;
		var visible = items.filter(o => {
			return !o.hide && (!o.permissions || (o.permissions.length > 0 && this.auth.hasAnyPermissionsArr(o.permissions)))
		});
		return visible.length > 0;
	}

  public setActions(actions, route, listIndex, formIndex) {
    //console.log(route + '|' + listIndex + '|' + formIndex)
		if (!actions)
			actions = new Array();
		var isSameForm = true;
		if (route != this.routeParams.route)
			this.actionsPerPanel.splice(0);
		this.routeParams = {
			route: route,
			listIndex: listIndex,
			formIndex: formIndex
		};
		var exists = this.actionsPerPanel.filter(z => {
			return z.route == this.routeParams.route && z.listIndex == this.routeParams.listIndex
		});
		if (exists.length > 0) {

		} else {
			this.actionsPerPanel.push({
				route: this.routeParams.route,
				listIndex: this.routeParams.listIndex,
				actions: this.actions,
				groupedActions: this.groupedActions
			})
		}

		if (isSameForm) {
			//Check if in list
			actions.forEach((o, index) => {
				var exists = this.actions.filter(ex => {
					return ex.label == o.label && ex.groupName == o.groupName
				});
				if (exists.length == 0) {
					o.newItem = true;
					this.actions.splice(index, 0, o);
				}
				else {
					this.setExisting(exists[0], o)
				}
			});

			//Remove if not in new list
			var toRemove = new Array();
			this.actions.forEach((o, index) => {
				var exists = actions.filter(ex => {
					return ex.label == o.label && ex.groupName == o.groupName
				})
				if (exists.length == 0)
					toRemove.push(o);
			})
			toRemove.forEach((o, index) => {
				this.actions.splice(this.actions.indexOf(o), 1);
			})
		}
		//else {
		//  this.actions = actions;
		//}
		this.groupActions(isSameForm);
	}
  public setExisting(exist, action) {
    //let objectPropertyDescriptors = Object.getOwnPropertyDescriptors(exist);
    //Object.keys(action).forEach(k => {
    //  let propertyDescriptors = objectPropertyDescriptors[k];
    //  if (!propertyDescriptors || (!propertyDescriptors.get || propertyDescriptors.set) || (!propertyDescriptors.get && !propertyDescriptors.set)) exist[k] = action[k];
    //});
    exist.command = action.command;
    exist.value = action.value;
    exist.permissions = action.permissions
	}

}
